import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { toastSelectors, toastActions } from 'store/toast';

const StyledToast = styled.div`
  width: ${scaleSize(640)}px;
  height: ${scaleSize(130)}px;
  border-radius: ${scaleSize(16)}px;
  position: absolute;
  left: ${scaleSize(640)}px;
  bottom: ${scaleSize(120)}px;
  text-align: center;
  box-shadow: 0 15px 40px 0 rgba(0, 0, 0, 0.5);
  background: #444444;
  color: #fff;
  z-index: 10;
`;

const StyledText = styled.span`
  font-family: 'RobotoRegular', sans-serif;
  font-size: ${scaleSize(32)}px;
  line-height: ${scaleSize(130)}px;
  height: ${scaleSize(48)}px;
`;

const TIMEOUT = 3000;

const Toast: React.FC = () => {
  const dispatch = useDispatch();
  const { text, isVisible } = useSelector(toastSelectors.selectToast);

  useEffect(() => {
    setTimeout(() => dispatch(toastActions.hideToast()), TIMEOUT);
  }, [dispatch, isVisible]);

  if (!isVisible) return null;

  return (
    <StyledToast>
      <StyledText>{text}</StyledText>
    </StyledToast>
  );
};

export default Toast;
